
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.333 3.333A1.667 1.667 0 015 1.667h6.667c.22 0 .433.088.589.244l4.166 4.167a.834.834 0 01.245.589v10A1.667 1.667 0 0115 18.333H5a1.667 1.667 0 01-1.667-1.666V3.333zm11.322 3.334l-2.988-2.989v2.989h2.988zM10 3.333H5v13.334h10V8.333h-4.167A.833.833 0 0110 7.5V3.333zm-3.333 7.5A.833.833 0 017.5 10h5a.833.833 0 010 1.667h-5a.833.833 0 01-.833-.834zm0 3.334a.833.833 0 01.833-.834h5a.833.833 0 010 1.667h-5a.833.833 0 01-.833-.833z"}})])
          )
        }
      }
    